/** @format */

import {getStatusData} from 'pages/HomeGrouping/helpers/getStatusData';
import {getTokenStatus} from 'pages/HomeGrouping/helpers/getTokenStatus';
import {type StatusDataInterface} from 'pages/HomeGrouping/types';

import {STATS_PROVIDERS} from 'pages/HomeGrouping/const';

import {OverviewCompany} from '../types';

export const getProjectStatuses = (company: OverviewCompany): StatusDataInterface[] => {
  const adTokens = company.tokens.filter(token => !STATS_PROVIDERS.includes(token.provider));

  const statuses = adTokens
    .map(token => getTokenStatus(company.stats, token))
    // «Готово» (READY) badge isn't shown — the user doesn't need an "all good" notification.
    .filter(status => status !== 'READY')
    .map(status => getStatusData(status, company.name))
    .filter((data): data is StatusDataInterface => data !== null);

  // Дедуп по title (несколько токенов с одинаковым статусом → один чип).
  const seen = new Set<string>();
  return statuses.filter(status => {
    if (seen.has(status.title)) {
      return false;
    }
    seen.add(status.title);
    return true;
  });
};
